import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSleep: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sleep, snooze, zzz"><path d="M3.75 8.75H8.25V9.5625L3.75 14.4375V15.25H8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 2.75H15.75V3.4375L11.75 7.5625V8.25H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 12.75H19.25V13.3571L12.75 20.6429V21.25H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSleep;
